var e=(e,t,a)=>({key:e,type:"textSearch",...a?{op:a}:{},value:t});export{e as makeFilterItemTextSearch};
//# sourceMappingURL=makeFilterItemTextSearch.js.map